export interface IColorLegendItem {
    color: string;
    borderColor?: string;
    borderWidth?: string;
    description: string;
}

export interface IColorLegendSection {
    title: string;
    items: IColorLegendItem[];
}

export const COLOR_LEGEND: IColorLegendSection[] = [
    {
        title: 'Availability Ratio',
        items: [
            {
                color: '#ffcdd2',
                borderColor: '#d32f2f',
                borderWidth: '2px',
                description: 'Light Red < 50%'
            },
            {
                color: '#fff9c4',
                borderColor: '#f57f17',
                borderWidth: '2px',
                description: 'Light Yellow < 80%'
            },
            {
                color: '#c8e6c9',
                borderColor: '#388e3c',
                borderWidth: '2px',
                description: 'Light Green ≥ 80%'
            }
        ]
    },
    {
        title: 'Discount Realized',
        items: [
            {
                color: '#ffebee',
                borderColor: '#c62828',
                borderWidth: '3px',
                description: 'Dark Red Frame > 15%'
            },
            {
                color: '#fffde7',
                borderColor: '#f57f17',
                borderWidth: '3px',
                description: 'Dark Yellow Frame > 5%'
            },
            {
                color: '#e8f5e9',
                borderColor: '#1b5e20',
                borderWidth: '3px',
                description: 'Dark Green Frame < 5%'
            }
        ]
    }
];
